import { Component, Input, ViewChild } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { OnDestroy, OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { JsonEditorOptions, JsonEditorComponent } from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';

import 'brace/mode/json'; // Modo xml para AceEditor
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-key-value-builder',
  templateUrl: 'keyValueBuilder.component.html'
})
export class KeyValueBuilderComponent implements OnDestroy, OnInit {
  // Referencia al editor de json
  @ViewChild(JsonEditorComponent) jsonEditor: JsonEditorComponent;

  /** Label que sera mostrado encabezando el componente */
  @Input() label = 'Key Value Builder';

  /** Labels para los inputs (por el momento solo se reconocen los dos primeros) */
  @Input() componentes: string[] = ['Key', 'Value'];
  @Input() classes: string[] = ['col-md-4', 'col-md-4'];

  @Input() viewData = true;

  /** Clave con las que seran asociados los valores de los inputs
   *  respectivamente, la primer clave va con el primer input y la
   *  segunda con el segundo
   */
  @Input() estructura: string[] = ['key', 'value'];

  mostrarConfirm = [];
  jsonInput = "";

  /**
   * Flag para tooglear el componente de extra info
   */
  advanced = false;

  /**
   * Tratamiento para los items, recibe un string, lo
   * transformamos a un array para mostrarlo y manipularlo
   * adentro del componente. A la hora de retornarlo se vuelve
   * a convertir en string;
   */
  _items: any[] = [];
  get items(): string {
    return JSON.stringify(this._items);
  }

  @Input('items')
  set items(valu: string) {
    // Si falla el parseo del string, capturamos el error
    // e inicializamos el array vacio
    try {
      this._items = JSON.parse(valu);
    } catch (e) {
      if (valu) {
        const item = { value: valu, desc: '' };
        const array = [];
        array.push(item);
        this._items = JSON.parse(JSON.stringify(array));
      } else {
        this._items = [];
      }
    }
  }

  /** Item auxiliar que se utilizar para ir pusheando nuevos elementos */
  newItem = {};
  editorOptions;

  constructor(private dragulaService: DragulaService, private alertService: AlertService, private sxTranslationService: SxTranslationService) {

    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.search = false;
    this.editorOptions.onChange = () => {
      // Cuando cambia el texto, intentamos parsear el texto
      // si falla no se actualiza el modelo, y se mustra un alert
      try {
        this.jsonInput = this.jsonEditor.getText();
        const obj = JSON.parse(this.jsonInput);
        this._items = obj;
      } catch (ex) {
        if(this.jsonInput != ""){
          let errorMessage: string = this.sxTranslationService.getResource('INVALIDJSON');
          alertService.showGrowl({
            type: GrowlType.DANGER,
            body: `${this.label} ${errorMessage}`,
          });
        }
      }
    };
    this.editorOptions.modes = ['view', 'code', 'form'];
  }

  ngOnInit() {
    this.dragulaService.setOptions(`items-bag-${this.label}`, {
      moves: (el, source, handle, sibling) => handle.className.includes('drag'),
    });
  }

  ngOnDestroy() {
    this.dragulaService.destroy(`items-bag-${this.label}`);
  }

  /**
   * Agrega un elemento a la lista
   */
  add() {
    this._items.push(this.newItem);
    this.newItem = {};
  }

  /**
   * Remueve el elemento en la posicion indicada
   * @param index indice del elemento a borrar
   */
  remove(index) {
    this._items.splice(index, 1);
    this.mostrarConfirm[index] = false;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/kevValueBuilder/keyValueBuilder.component.ts